export default import.meta.ROLLUP_FILE_URL_p9L4fEVyJ4NKBeuEB9VL6w